export default "__VITE_ASSET__EauhgIar__"